import classNames from "classnames";
import ReactSelect, {
  Props as ReactSelectProps,
  SingleValue,
} from "react-select";

type Option = { value: string; label: string };

export type SelectProps = Pick<
  ReactSelectProps<Option, false>,
  "placeholder"
> & {
  options: Option[];
  value: string;
  onChange: (value: string | undefined) => void;
  error?: string | boolean;
  className?: string;
};

export const Select: React.FC<SelectProps> = (props) => {
  const usedValue: Option | null =
    props.options?.find((option) => option.value === props.value) ?? null;

  const innerOnChange = (option: SingleValue<Option>) => {
    props.onChange(option?.value ?? undefined);
  };

  return (
    <div>
      <ReactSelect
        isMulti={false}
        placeholder={props.placeholder}
        value={usedValue}
        onChange={innerOnChange}
        classNames={{
          control: ({ isFocused }) =>
            classNames(
              "!rounded-lg !border focus:ring-1",
              {
                "!border-gray-500": !props.error,
                "!ring-1": isFocused,
                "!ring-1, !ring-error !border-error": props.error,
              },
              props.className,
            ),
          container: () => "flex-1",
          placeholder: () => "!text-gray-500",
          valueContainer: () => "!py-2.5",
          indicatorSeparator: () => "hidden",
          option: ({ isSelected }) =>
            isSelected ? "!bg-primary !text-white" : "",
        }}
        isSearchable={false}
        options={props.options}
      />
      {typeof props.error === "string" && (
        <p className="ml-1 text-sm text-error">{props.error}</p>
      )}
    </div>
  );
};
